import { createState, useState } from '@hookstate/core';
import { UserInfo } from 'shared/types';

interface AuthState {
  user: UserInfo | null;
}

const initialState: AuthState = {
  user: null,
};

const authState = createState(initialState);

export function useAuthState() {
  return useState(authState);
}
